<template>
  <div >
    <div>
      {{ heatmap.name }}
    </div>
    <table>
      <tbody>
        <tr v-for="([name, color]) in rows" :key="name">
          <td>
            {{ name }}
          </td>
          <td :style="{ paddingLeft: '10px' }">
            <div
              :style="{
                width: '30px',
                height: '15px',
                backgroundColor: color
              }"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    heatmap: {
      type: Object,
      required: true
    }
  },
  computed: {
    rows () {
      return Object.entries(this.heatmap.legend)
    }
  }
}
</script>